import { jsxs, jsx } from "react/jsx-runtime";
import { Text } from "@zillow/constellation-10";
import { FAQ } from "@zillow/zrs-cms";
import PropTypes from "prop-types";
import "react";
import { generateBlockList } from "../../components/BlockList/BlockList.esm.js";
const FAQItem = ({
  index,
  attrs: {
    heading,
    id
  },
  innerBlocks
}) => /* @__PURE__ */ jsxs(FAQ.Item, { as: "div", id, children: [
  /* @__PURE__ */ jsx(FAQ.Header, { as: "dt", children: /* @__PURE__ */ jsx(Text, { textStyle: "body-bold", children: heading }) }),
  /* @__PURE__ */ jsx(FAQ.Panel, { as: "dd", children: generateBlockList({
    blocks: innerBlocks
  }) })
] }, index);
FAQItem.propTypes = {
  index: PropTypes.number,
  attrs: PropTypes.shape({
    heading: PropTypes.string,
    id: PropTypes.string
  }),
  innerBlocks: PropTypes.arrayOf(PropTypes.shape({}))
};
export {
  FAQItem as default
};
